export default __webpack_public_path__ + "static/media/rabbit29.a7009746.gif";